import(/* webpackMode: "eager" */ "/vercel/path0/app/waitlist/page.tsx");
